/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';
import CombineToolIcon from 'icons/CombineToolIcon';

const messages = defineMessages({
  title: {id: 'navigation.data-tools.combine'},
});

const CombineItem = () => (
  <RouteLinkItem
    iconBefore={CombineToolIcon}
    route="midas/data-tools/combine-tool"
    title={messages.title}
  />
);

export default CombineItem;
